const DAY_IN_MS = 1000 * 60 * 60 * 24;

export function isBeforeToday(isoDate?: string | Date | null): boolean {
    if (!isoDate) {
        return false;
    }

    const date = new Date(isoDate);
    const today = new Date();

    return date < today;
}

export function withinDays(startDateString: string | Date, endDateString: string | Date, days: number): boolean {
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    const daysDifference = Math.round((endDate.getTime() - startDate.getTime()) / DAY_IN_MS);

    return daysDifference >= 0 && daysDifference < days;
}

export function oneHourFromNow(): Date {
    const date = new Date();

    date.setHours(date.getHours() + 1);

    return date;
}

export function oneDayFromNow(): Date {
    const date = new Date();

    date.setDate(date.getDate() + 1);

    return date;
}

export function getDate(isoDate?: string): null | string {
    if (!isoDate) {
        return null;
    }

    const date = new Date(isoDate);

    return `${ date.getMonth() + 1 }/${ date.getDate() }/${ date.getFullYear() }`;
}

export function daysSince(dateString: string): number {
    const today = new Date();
    const givenDate = new Date(dateString);

    return Math.round((today.getTime() - givenDate.getTime()) / DAY_IN_MS);
}

export function formatDateMMDDYYYY(startDate: null | string): null | string {
    if (!startDate) {
        return null;
    }

    const date = new Date(startDate);

    return `${ date.getUTCMonth() + 1 }/${ date.getUTCDate() }/${ date.getUTCFullYear() }`;
}

export function getDateAfterNMonths(isoDate: string, n: number): string {
    const date = new Date(isoDate);
    
    date.setMonth(date.getMonth() + n);

    return `${ date.getMonth() + 1 }/${ date.getDate() }/${ date.getFullYear() }`;
}
